export const ModalSpecialTrackTableConfig = [
  {
    title: "커리큘럼 ID",
    dataIndex: "id"
  },
  {
    title: "스페셜트랙 제목",
    dataIndex: "specialTrackTitle"
  },
  {
    title: "과정명",
    dataIndex: "curriculumName"
  },
  {
    title: "선택",
    dataIndex: "",
    scopedSlots: {
      customRender: "choice"
    }
  }
];
